import * as RequestAccessDAO from 'auth/RequestAccessDAO';

export function requestAccess(id: string): void {
  RequestAccessDAO.requestAccess(id);
}
